export default "__VITE_ASSET__CtoHLyxT__"